import Icon from '@components/icons/Icon';
import { IconButton, theme } from 'aimo-ui';
import { ButtonTypes } from 'aimo-ui/lib/typescript/src/components/Button/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

type BackButtonProps = {
  onPress?: () => void;
  testID?: string;
  buttonType?: ButtonTypes;
};

const BackIcon = ({ color }: { color: string }) => (
  <Icon name="back" size="s" color={color} />
);

const BackButton = ({
  onPress,
  testID,
  buttonType = 'tertiary',
}: BackButtonProps) => {
  const { t } = useTranslation();

  return (
    <IconButton
      fullWidth={false}
      buttonType={buttonType}
      onPress={onPress}
      rounded
      testID={testID}
      accessibilityLabel={t('ariaLabels.goBack')}
      iconComponent={() =>
        BackIcon({
          color:
            buttonType === 'secondary'
              ? theme.colors.white
              : theme.colors.black,
        })
      }
    />
  );
};

export default BackButton;
